<template>
    <div>
         <span style="width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
            <NavBar_Fusion v-bind:item="item"></NavBar_Fusion>

            <div>
                    <v-container>
                        <v-row style="text-align: center;width:100%;" v-for="(item,k) in this.$store.getters.getActiveBiomarker"  v-bind:key="k">
                        <v-col cols="12" md="12" lg="12" xl="12" style="text-align:center;">
                            <v-card
                             class="elevation-2 content-box"
                            >
                               <v-list v-if="'merged_evidence_data' in item.onkopus_aggregator">
                                    <v-list-group value="metakb" dark color="#0086d0" style="text-align:left;" density="compact">
                                    <template v-slot:activator="{ props }">
                                        <v-list-item
                                            v-bind="props"
                                            prepend-icon="mdi-account-circle"
                                            :title="'All Results (' + item.onkopus_aggregator.merged_evidence_data.length + ')'"
                                        ></v-list-item>
                                    </template>

                                    <v-table style="width:100%;text-align:left;">
                                        <thead>
                                            <tr style="background-color:#f0f0f0;">
                                                   <th @click="sortTreatmentList('gene')" class="tb-variants-col">
                                                        <v-table class="cs-table">
                                                            <tr>
                                                                <td>
                                                                    Found Alteration
                                                                </td>
                                                                <td>
                                                                    <span><v-icon :icon="this.iconStatesUp['variant']" /></span>
                                                                    <span><v-icon :icon="this.iconStatesDn['variant']" /></span>
                                                                </td>

                                                            </tr>
                                                        </v-table>
                                                   </th>
                                                   <th>
                                                    <td>Match Type</td>
                                                   </th>
                                                   <th @click="sortTreatmentList('disease')" class="tb-variants-col">
                                                        <v-table class="cs-table">
                                                            <tr>
                                                                <td>
                                                                    Disease
                                                                </td>
                                                                <td>
                                                                    <span><v-icon :icon="this.iconStatesUp['disease']" /></span>
                                                                    <span><v-icon :icon="this.iconStatesDn['disease']" /></span>
                                                                </td>
                                                            </tr>
                                                        </v-table>
                                                   </th>
                                                   <th @click="sortTreatmentList('disease')" class="tb-variants-col">
                                                        <v-table class="cs-table">
                                                            <tr>
                                                                <td>
                                                                    Drug Class
                                                                </td>
                                                                <td>
                                                                    <span><v-icon :icon="this.iconStatesUp['disease']" /></span>
                                                                    <span><v-icon :icon="this.iconStatesDn['disease']" /></span>
                                                                </td>
                                                            </tr>
                                                        </v-table>
                                                   </th>
                                                   <th @click="sortTreatmentList('drugs')" class="tb-variants-col">
                                                        <v-table class="cs-table">
                                                            <tr>
                                                                <td>
                                                                    Drugs
                                                                </td>
                                                                <td>
                                                                    <span><v-icon :icon="this.iconStatesUp['drugs']" /></span>
                                                                    <span><v-icon :icon="this.iconStatesDn['drugs']" /></span>
                                                                </td>
                                                            </tr>
                                                        </v-table>
                                                   </th>
                                                   <th @click="sortTreatmentList('evidence_level')" class="tb-variants-col">
                                                        <v-table class="cs-table">
                                                            <tr>
                                                                <td>
                                                                    Evidence Level
                                                                </td>
                                                                <td>
                                                                    <span><v-icon :icon="this.iconStatesUp['evidence_level']" /></span>
                                                                    <span><v-icon :icon="this.iconStatesDn['evidence_level']" /></span>
                                                                </td>
                                                            </tr>
                                                        </v-table>
                                                   </th>
                                                   <th @click="sortTreatmentList('response')" class="tb-variants-col">
                                                        <v-table class="cs-table">
                                                            <tr>
                                                                <td>
                                                                    Response Type
                                                                </td>
                                                                <td>
                                                                    <span><v-icon :icon="this.iconStatesUp['response']" /></span>
                                                                    <span><v-icon :icon="this.iconStatesDn['response']" /></span>
                                                                </td>
                                                            </tr>
                                                        </v-table>
                                                   </th>
                                                   <th @click="sortTreatmentList('citation_url')" class="tb-variants-col">
                                                        <v-table class="cs-table">
                                                            <tr>
                                                                <td>
                                                                    Citation
                                                                </td>
                                                                <td>
                                                                    <span><v-icon :icon="this.iconStatesUp['citation_url']" /></span>
                                                                    <span><v-icon :icon="this.iconStatesDn['citation_url']" /></span>
                                                                </td>
                                                            </tr>
                                                        </v-table>
                                                   </th>
                                                   <th @click="sortTreatmentList('source')" class="tb-variants-col">
                                                        <v-table class="cs-table">
                                                            <tr>
                                                                <td>
                                                                    Source
                                                                </td>
                                                                <td>
                                                                    <span><v-icon :icon="this.iconStatesUp['source']" /></span>
                                                                    <span><v-icon :icon="this.iconStatesDn['source']" /></span>
                                                                </td>
                                                            </tr>
                                                        </v-table>
                                                   </th>
                                                   <th>
                                                        Info
                                                   </th>
                                            </tr>
                                         </thead>
                                         <tbody>
                                              <tr v-for="(item_ce,key_ce) in item.civic.any_mutation_in_gene"  v-bind:key="key_ce">
                                                   <td>{{ item_ce.biomarker }}</td>
                                                   <td>{{ item_ce.match_type_str }}</td>
                                                   <td>{{ item_ce.disease }}</td>

                                                   <td>
                                                        <span v-for="drug in item_ce.drugs" v-bind:key="item_ce.drugs.drug_name">
                                                            {{ drug.drug_class }}<br/>
                                                        </span>
                                                    </td>
                                                   <!--<td>{{ item_ce.drug_class }}</td>-->

                                                   <td>
                                                        <span v-for="drug in item_ce.drugs" v-bind:key="item_ce.drugs.drug_name">
                                                            {{ drug.drug_name }}<br/>
                                                        </span>
                                                    </td>

                                                   <!--<td>{{ item_ce.drugs }}</td>-->
                                                   <td>{{ item_ce.evidence_level_onkopus }}</td>
                                                   <td>{{ item_ce.response }}</td>
                                                   <td>
                                                        <a :href="item_ce.citation_url" class="citation-id-link" style="text-decoration:None;">
                                                            {{ item_ce.citation_id }}
                                                        </a>
                                                   </td>
                                                   <!--<td><a href="{{ item_ce.citation_url }}">{{ item_ce.citation_url }}</a></td>-->

                                                   <td>{{ item_ce.source }}</td>
                                                   <td>
                                                        <v-btn @click="overlay = !overlay">
                                                            Info
                                                        </v-btn>
                                                        <v-menu activator="parent">
                                                            <v-list>
                                                                <v-list-item>
                                                                    <v-list-item-title>{{ item_ce.evidence_statement }}</v-list-item-title>
                                                                </v-list-item>
                                                            </v-list>
                                                        </v-menu>
                                                   </td>
                                              </tr>
                                         </tbody>
                                     </v-table>

                                     </v-list-group>
                                   </v-list>
                                 </v-card>

                        </v-col>
                   </v-row>
                </v-container>
            </div>

         </span>
    </div>
</template>
<script>
import Loading from 'vue-loading-overlay';
import NavBar_Fusion from '@/components/navbars/NavBar_Fusion';
import active_variants from "@/methods/active_variants";

export default {
    name: 'FusionTreatments',
    components: {
        Loading,
        NavBar_Fusion,
    },
    data: () => ({
        isLoading: false,
        fullPage: true,
        overlay: false,
        open: ['metakb'],
        sunburst_plot: "",
                sortStates: {
            'gene': 0,
            'variant': 0,
            'disease': 0,
            'drugs': 0,
            'evidence_level': 0,
            'response': 0,
            'citation_url': 0,
            'source': 0
        },
        iconStatesUp: {
            'gene': 'mdi-arrow-up-thin',
            'variant': 'mdi-arrow-up-thin',
            'disease': 'mdi-arrow-up-thin',
            'drugs': 'mdi-arrow-up-thin',
            'evidence_level': 'mdi-arrow-up-thin',
            'response': 'mdi-arrow-up-thin',
            'citation_url': 'mdi-arrow-up-thin',
            'source': 'mdi-arrow-up-thin'
        },
        iconStatesDn: {
            'gene': 'mdi-arrow-down-thin',
            'variant': 'mdi-arrow-down-thin',
            'disease': 'mdi-arrow-down-thin',
            'drugs': 'mdi-arrow-down-thin',
            'evidence_level': 'mdi-arrow-down-thin',
            'response': 'mdi-arrow-down-thin',
            'citation_url': 'mdi-arrow-down-thin',
            'source': 'mdi-arrow-down-thin'
        },
    }),
    created: async function() {
        this.isLoading=true
        await active_variants.loadActiveBiomarkerFusion(this.$route.params.id)
        this.isLoading=false
    }
}
</script>
<style>
</style>
